<template>
    <div v-loading="loading" element-loading-text="数据同步中。。。">
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtKey"  placeholder="公告名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">
                <el-radio-group v-model="pgData.txtKey2" @change="searchHandler">
                    <el-radio-button label="1">未审核公告</el-radio-button>
                    <el-radio-button label="6">已审核公告</el-radio-button>
                    <el-radio-button label="9">已发布公告</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公告名称" prop="by1" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="中标价格" prop="zbjg" sortable width="110">
                <template slot-scope="scope">
                    <div v-if="scope.row.bjlx==='2'||scope.row.bjlx==='3'||scope.row.bjlx==='4'">
                        {{scope.row.zbbj}}                    
                    </div>
                    <div v-else>
                        {{scope.row.zbjg}}元
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="发布时间" prop="createdate" sortable width="150"></el-table-column>
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <state-list :row="scope.row" :config="STATE_CONF" v-if="scope.row.shbj!=='3'"></state-list>
                    <my-tag type="danger" v-if="scope.row.shbj==='3'">
                        <div class="reason">
                            退回{{scope.row.by2}}
                        </div>    
                    </my-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" min-width="150" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/auditzbjggg/get_list.json`">
        </my-pagination>

       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'


import STATE_CONF from './config/zbjggg-state'
import BTN_CONF from './config/zbjggg-btn-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData: {
                txtKey:'',
                txtKey2: '1',
                sortname:'shbj'
            },
            loading:false,
            
            STATE_CONF,
            BTN_CONF
        }
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {
    
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
